const en = {
    all: 'All',
    allowed: 'Allowed',
    already_have_account: 'Already have an sections?',
    and: 'and',
    back: 'back',
    by_registering_agree: 'By registering, I agree to CodeAcademy Kids',
    change_password: 'change password',
    code: 'Code',
    code_required: 'Code is required',
    confirm_new_password: 'Confirm New Password',
    content: 'Content',
    dashboard: 'Dashboard',
    didnt_receive_email: `Didn't receive an email?`,
    dont_have_account: `Don't have an account?`,
    email_address: 'Email address',
    email_address_must_be_from_codeacademy_domain: 'Must be a valid CodeAcademy email',
    email_address_must_be_valid: 'Email must be a valid email address',
    email_address_required: 'Email address is required',
    email_address_must_be_different_than_yours: 'Email address must be different than yours',
    enter_new_password_subtitle: 'Please enter your new password that will be associated with your sections.',
    enter_new_password_title: 'Enter your new password',
    error_fetching_lessons: 'Something went wrong fetching the lessons.',
    error_fetching_modules: 'Something went wrong fetching the modules.',
    error_fetching_topic_content: 'Something went wrong fetching the topic content.',
    error_fetching_topics: 'Something went wrong fetching the topics.',
    finish: 'Finish',
    first_name: 'First name',
    first_name_required: 'First name is required',
    forgot_password: 'Forgot password',
    forgot_your_password_details:
        'Please enter the email address associated with your sections and we will email you a link to reset your password.',
    forgot_your_password_title: 'Forgot your password?',
    general: 'general',
    go_to_home: 'Go to Home',
    group: 'Group',
    group_content: 'Group Content',
    groups: 'Groups',
    groups_content: "group's content",
    groups_content_updates: `Group's content updated`,
    home: 'Home',
    incorrect_or_tampered_link: 'Incorrect or tampered link',
    internal_server_error: 'Internal Server Error',
    internal_server_error_description:
        'There was an error. Please try again later or contact your system administrator.',
    last_name: 'Last name',
    last_name_required: 'Last name is required',
    latest: 'Latest',
    lesson: 'Lesson',
    lessons: 'Lessons',
    link_to_login_text: 'Login',
    link_to_registration_text: 'Get started',
    login: `Login`,
    login_form_subtitle: `Enter your credentials below.`,
    login_form_title: 'Sign in to CodeAcademy Kids',
    login_greeting_title: 'Welcome Back!',
    login_illustration: 'login illustration',
    login_with_google: `Login with Google`,
    logout: `Logout`,
    module_code: 'Module code',
    module_illustration: 'module illustration',
    modules: 'Modules',
    name: 'Name',
    new_password: 'New Password',
    new_password_helper_text: 'Password must be minimum 8+',
    new_password_required: 'New password is required',
    next: 'Next',
    no_lessons_found: 'No lessons found',
    no_modules_found: 'No modules found. Modules will appear here as soon as teacher unlocks them for your class.',
    no_results_for: 'No results found for',
    no_results_helper_text: 'Try checking for typos or using complete words.',
    no_topics_found: 'No topics found',
    not_found: 'Not found',
    notifications: 'notifications',
    old_password: 'Old Password',
    old_password_required: 'Old Password is required',
    unlock_lessons_helper_text: 'Empty value means module is not visible',
    opened_lessons: 'Opened lessons',
    page_not_found: 'Page Not Found',
    page_not_found_description:
        "Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling.",
    password: 'Password',
    password_must_be_at_least_8_characters: 'Password must be at least 8 characters',
    password_must_match: 'Passwords must match',
    password_required: 'Password is required',
    please_check_your_email: 'Please check your email.',
    please_try_again_or_contact_admin:
        'Please try again later or contact your system administrator if the issue persists.',
    privacy_policy: 'Privacy Policy',
    points: 'points',
    redirecting: 'Redirecting',
    register: `Register`,
    register_illustration: 'register illustration',
    registration_form_subtitle: `Exclusively dedicated to the customers of CodeAcademy Kids.`,
    registration_form_title: 'Join CodeAcademy Kids',
    registration_greeting_title: `An online education platform to support our students`,
    remember_me: 'Remember me',
    confirm_email: 'Confirm your email address',
    resend_email: 'Resend email',
    reset_password: 'Reset Password',
    reset_password_greeting_title: 'Get back on track and continue learning',
    reset_password_illustration: 'reset password illustration',
    save_changes: 'Save Changes',
    please_fill_all_fields: 'Please fill all fields before saving',
    search_groups: 'Search groups',
    sent_confirmation_email_to: 'We have sent a confirmation email to',
    confirmation_email_success: 'We have re-sent a confirmation email. Please also check span folder.',
    confirmation_email_failure: 'Something went wrong. Please try again later.',
    set_password: 'Set Password',
    something_went_wrong: 'Something went wrong.',
    sorted_ascending: 'sorted ascending',
    sorted_descending: 'sorted descending',
    terms_of_service: 'Terms of Service',
    too_long: 'Too Long!',
    too_short: 'Too Short!',
    topic: 'Topic',
    topics: 'Topics',
    unable_to_logout: `Unable to logout!`,
    update_photo: 'Update photo',
    upload_photo: 'Upload photo',
    user: 'User',
    user_management: 'Account Management',
    verify: 'Verify',
    verify_code_subtitle: "Enter a 6 characters confirmation code. If you don't have one, please contact staff.",
    verify_code_title: 'Please enter your verification code',
    verify_email_and_code_illustration: 'verify email and code illustration',
    verify_email_subtitle_part_1: 'We have sent you a confirmation link to',
    verify_email_subtitle_part_2: 'please click that link to verify your email.',
    verify_email_title: 'Please check your email!',
    check_spam_folder: 'If you do not receive the email, please check your spam folder.',
    view_lesson: 'View lesson',
    view_module: 'View module',
    your_account: 'Your sections',
    lastest_lesson: 'Latest Lesson',
    all_lessons: 'All Lessons',
    unlock_lessons: 'unlock lessons',
    settings: 'settings',
    group_not_assigned:
        "You are not yet assigned to any group. Wait information from your group coordinator or lecturer. If you have any other question don't hesitate to reach out.",
    // ---------------LANGUAGE SETTINGS---------------
    language: 'language',
    language_preference: 'Language perference',
    language_preference_saved: 'Language preference updated successfully',
    language_required: 'Language preference is required',
    login_success: 'Logged in successfully',
    register_success: 'Registered successfully',
    user_update_success: 'Account profile updated successfully',
    password_update_success: 'Password updated successfully',
    password_reset_success: 'Password reset successfully',
    password_reset_code_verified: 'Password reset code verified',
    'auth/invalid-verification-code':
        'The verification code you entered is invalid. Please double-check the code and try again, or request a new code if necessary.',
    'auth/email-already-in-use':
        'The email address you provided is already associated with an existing account. Please log in using that email or choose a different one to create a new account.',
    'auth/expired-action-code': 'The link you used has expired. Please request a new link to continue.',
    'auth/invalid-action-code': 'The link is invalid or has already been used. Please request a new link to proceed.',
    'auth/invalid-email': 'The email address you entered is not valid. Please check the format and try again.',
    'auth/invalid-user-token': 'Your session has become invalid. Please log in again to continue.',
    'auth/user-disabled': 'Your account has been disabled. Please contact customer support for assistance.',
    'auth/user-not-found':
        'No account was found with the provided information. Please check your credentials or sign up for a new account.',
    'auth/user-token-expired': 'Your session has expired. Please log in again to continue.',
    'auth/weak-password':
        'The password you entered is too weak. Please choose a stronger password that meets our security requirements.',
    'auth/wrong-password':
        "The email or password you entered is incorrect. Please try again or reset your password if you've forgotten it.",
    'auth/no-stripe-customer':
        "We couldn't find a customer associated with this email. If you're a parent, make sure you use the same email address to which you get invoices. If you're a student, please ask your parent or guardian to invite you by going Children -> Add New Child.",
    'db/no-document': 'No records were found matching your query. Please modify your search criteria and try again.',
    last_updated: 'Last Updated',
    by: 'by',
    past_due: 'Past Due',
    billing: 'Billing',
    cancel_plan: 'Cancel Plan',
    manage_plan: 'Manage Plan',
    your_enrollments: 'Your enrollments',
    assign_child: 'Assign children',
    assign_child_warning: 'You can assign children only once. You cannot change it later.',
    assign_child_success: 'We successfully assigned children to subscription',
    assign_child_failure: 'Something went wrong. Please try again later.',
    month: 'month',
    // ---------------CANCEL PLAN MODAL---------------
    plan_cancellation: 'Plan Cancellation',
    plan_cancellation_text: 'By canceling the plan it will be deleted permanently!',
    cancel_plan_discard: 'No, keep it',
    cancel_plan_accept: 'Yes, cancel this plan',
    tooExpensive: "It's too expensive",
    notUsingOften: 'I am not using this plan too often',
    tooDifficult: 'The program is too difficult',
    didntWorkAsExpected: 'The service/program do not work as expected',
    techIssues: "I'm having too many technical issues",
    changePlan: 'I want to change the plan',
    Other: 'Other',
    other_reason_text_field: 'Other reason',
    reason_required_error: 'Please select cancellation reason',
    other_reason_required_error: 'Please say cancellation reason',
    request_to_cancel_plan: "Request to cancel plan submitted successfully. We'll get back to you shortly.",
    // ---------------GROUP LIST---------------
    group_list: 'Group List',
    create_new_group: 'Create New Group',
    new_group: 'New Group',
    edit_group: 'Edit group',
    create_group: 'Create Group',
    list: 'List',
    students: 'Students',
    availability: 'Availability',
    active: 'Active',
    graduated: 'Graduated',
    inactive: 'Inactive',
    full: 'Full',
    available: 'Available',
    online: 'Online',
    live: 'Live',
    search: 'Search',
    clear: 'Clear',
    no_data: 'No data',
    selected: 'Selected',
    delete: 'Delete',
    edit: 'Edit',
    items: 'items',
    are_you_sure_you_want_to_delete: 'Are you sure want to delete',
    cancel: 'Cancel',
    student_points: 'Student points',
    // ---------------GROUP FORM---------------
    group_name: 'Group name',
    group_id: 'Group id',
    product: 'Product',
    general_info: 'General info',
    teachers: 'Teachers',
    teacher_name: 'Teacher name',
    select_teacher: 'Select teacher',
    add_teacher: 'Add teacher',
    learning_mode: 'Learning mode',
    schedule: 'Schedule',
    max_students: 'Max students',
    remove: 'Remove',
    select_student: 'Select student',
    add_student: 'Add student',
    address: 'Address',
    city: 'City',
    city_required_error: 'Please enter city',
    address_required_error: 'Please enter address',
    start_date: 'Start date',
    end_date: 'End date',
    status: 'Status',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    start_time: 'Start time',
    end_time: 'End time',
    repeat_interval: 'Repeat interval',
    once: 'Once',
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    monthly: 'Monthly',
    bimonthly: 'Bi-monthly',
    id_required_error: 'Please enter group id',
    name_required_error: 'Please enter group name',
    max_students_required_error: 'Please enter max students',
    product_required_error: 'Please select product',
    mode_required_error: 'Please select learning mode',
    status_required_error: 'Please select status',
    failed_to_create_group: 'Failed to create group',
    failed_to_update_group: 'Failed to update group',
    successfully_created_group: 'Successfully created group',
    successfully_updated_group: 'Successfully updated group',
    failed_to_delete_group: 'Failed to delete group',
    failed_to_delete_groups: 'Failed to delete groups',
    successfully_deleted_group: 'Successfully deleted group',
    successfully_deleted_groups: 'Successfully deleted groups',
    confirm_changes: 'Confirm changes',
    review_changes_before_updating: 'Review changes before updating',
    before: 'Before',
    after: 'After',
    confirm: 'Confirm',
    // ---------------USER FORM---------------
    role_required_error: 'Pasirinkite vartotojo rolę',
    // --------------- ATTENDANCE ---------------
    attendance: 'Attendance',
    account: 'Account',
    log_attendance: 'Log attendance',
    student: 'Student',
    select_group_student: 'Select group and student',
    select_group_and_student: 'Select group and student',
    present: 'Present',
    absent: 'Absent',
    late: 'Late',
    left_early: 'Left early',
    comment: 'Comment',
    group_comment: 'Comment for group',
    student_comment: 'Comment for student',
    is_approved: 'Points are checked and approved',
    attendance_percentage: 'Attendance percentage',
    select: 'Select',
    select_date: 'Select date',
    role: 'Role',
    admin: 'Admin',
    child: 'Child',
    teacher: 'Teacher',
    parent: 'Parent',
    '': '',
    no_students: 'No students',
    attendance_required: 'Please select attendance',
    comment_min_3_characters: 'Comment must be at least 3 characters',
    successfully_save_daily_sheet: 'Successfully saved attendance & rewards',
    no_lecture_on_this_date: 'No lecture on this date in the schedule. Please check if you selected correct date.',
    failed_to_save_daily_sheet: 'Failed to saved attendance & rewards',
    permission_denied: 'Permission denied',
    no_permission_to_access_page: 'You do not have permission to access this page.',
    feature_not_available: 'Feature not available',
    feature_disabled_for_group: 'This feature is disabled for this group.',
    only_students_can_claim_rewards:
        'Only students can claim rewards for themselves. Parents can view rewards but cannot claim them.',
    select_year: 'Select year',
    today: 'Today',
    no_groups_found: 'No groups found',
    my_studies: 'My studies',
    contact_sales: 'Contact sales to subscribe',
    via_email: 'via email',
    via_phone: 'via phone',
    manage_plans: 'Manage plans',
    left: 'Left',
    no_child_selected: 'No child selected',
    no_records: 'No records',
    assign_to_plan: 'Assign to plan',
    close: 'Close',
    child_already_assigned: 'Child already assigned',
    no_child_assigned: 'No child assigned',
    or: 'or',
    no_subscriptions: 'No subscriptions',
    or_select_existing_child: 'or select existing child',
    already_existing_child: 'Want to assign existing child?',
    select_child: 'Select child',
    dont_have_existing_child: "Didn't add your child yet?",
    sent_invitation_mail: 'Invitation sent email via ',
    meeting_link_required_error: 'Please enter meeting link',
    meeting_link: 'Meeting link',
    meeting_links: 'Meeting links',
    comma_separated_links: 'Comma-separated links',
    meeting_information: 'Meeting information',
    meeting_recordings_required_error: 'Please enter meeting recordings link',
    meeting_recordings: 'Meeting recordings',
    taken: 'Taken',
    week: 'Week',
    day: 'Day',
    monday_meeting_link: 'Monday meeting link',
    tuesday_meeting_link: 'Tuesday meeting link',
    wednesday_meeting_link: 'Wednesday meeting link',
    thursday_meeting_link: 'Thursday meeting link',
    friday_meeting_link: 'Friday meeting link',
    saturday_meeting_link: 'Saturday meeting link',
    sunday_meeting_link: 'Sunday meeting link',
    agenda: 'Agenda',
    join_zoom_meeting: 'Join Zoom Meeting',
    instructions: 'Instructions',
    management: 'Management',
    analytics: 'Analytics',
    max_points_per_student: 'Max points',
    export_csv: 'Export CSV',
    // --------------- USERS ---------------
    users: 'Users',
    new_user: 'New user',
    create_new_user: 'Create new user',
    edit_user: 'Edit user',
    failed_to_create_user: 'Failed to create user',
    failed_to_update_user: 'Failed to update user',
    create_user: 'Create user',
    parent_id: 'Parent User ID',
    parent_id_required_error: 'Please enter parent user ID',
    stripe_id: 'Stripe ID',
    verify_email: 'Verify email',
    verified: 'Verified',
    unverified: 'Unverified',
    email_verified: 'Email verified',
    successfully_verified_email: 'El. paštas sėkmingai patvirtintas',
    failed_to_verify_email: 'Nepavyko patvirtinti el. pašto. Bandykite dar kartą.',
    stripe_id_required_error: 'Please enter stripe ID',
    successfully_created_user: 'Successfully created user',
    successfully_updated_user: 'Successfully updated user',
    failed_to_delete_user: 'Failed to delete user',
    failed_to_delete_users: 'Failed to delete users',
    successfully_deleted_user: 'Successfully deleted user',
    successfully_deleted_users: 'Successfully deleted users',
    // --------------- CHILDREN ---------------
    children: 'Children',
    new_child: 'New child',
    edit_child: 'Edit child',
    invited: 'Invited',
    registered: 'Registered',
    resend_invitation: 'Resend invitation',
    invite_child: 'Send invite',
    invite_new_child: 'Invite new child',
    add_child: 'Add new child',
    birthDate: 'Birth date',
    birth_date_required: 'Please enter birth date',
    must_be_at_least_6_years_old: 'Must be at least 6 years old',
    must_be_no_older_than_19_years_old: 'Must be no older than 19 years old',
    successfully_updated_child: 'Successfully updated child',
    successfully_invited_child: 'Successfully added child. Invitation sent to email',
    resend_child_invite_success: 'We re-sent invitation email via provided email address',
    resend_child_invite_failure: 'Failed to re-send invitation email. Please try again',
    email: 'Email',
    group_required_error: 'Please select group',
    start_date_required_error: 'Please enter start date',
    end_date_required_error: 'Please enter end date',
    'event.new_event': 'Create new event',
    'event.update': 'Update event',
    'event.create': 'Create event',
    'event.end_date_later_than_start_date': 'End date must be later than start date',
    successfully_created_event: 'Successfully created event',
    successfully_updated_event: 'Successfully updated event',
    successfully_deleted_event: 'Successfully deleted event',
    failed_to_create_event: 'Failed to create event',
    failed_to_update_event: 'Failed to update event',
    failed_to_delete_event: 'Failed to delete event',
    // --------------- REWARDS ---------------
    space_odyssey: 'Space Odyssey',
    date: 'Data',
    place: 'Place',
    points_for_questions: 'For questions',
    points_for_attendance: 'For attendance',
    points_for_ideas: 'For ideas',
    points_for_practices: 'For practices',
    points_for_helping_others: 'For helping others',
    points_for_challenges: 'For challenges - missions',
    challenge_points: 'Challenge points and information',
    extra_points: 'Extra points',
    rewards: 'Rewards',
    choose: 'Choose',
    reward: 'Reward',
    additional_comment: 'Additional comments',
    claim_reward: 'Claim reward',
    cancel_claim_reward: "I've changed my mind",
    leaderboard: 'Leaderboard',
    claimed: 'Claimed',
    view: 'View',
    order: 'Order',
    to_unlock: 'to unlock',
    balance_sheet_and_rules: 'Balance sheet and rules',
    failed_to_load_rewards: 'Failed to load rewards. Try again later',
    insufficient_points: 'You do not have enough points to claim this reward',
    reward_already_claimed: 'This reward has already been claimed',
    claimed_reward: 'Claimed reward',
    points_deducted: 'Points deducted',
    reward_ordered: 'Reward is ordered. Our team will be in touch with you shortly.',
    teacher_prizes: 'Prizes',
    all_prizes_overview_for_teachers: 'All Prizes Overview',
    teacher_prizes_description:
        'Here you can view all available prizes sorted by levels. This helps you understand what rewards students are working towards.',
    available_options: 'Available Options',
    no_options_available: 'No options available for this prize',
    quantity: 'Quantity',
    category: 'Category',
    description: 'Description',
    total: 'Total',
    skipped: 'Skipped',
    in_a_row: 'in a row',
    balance: 'Balance',
    diploma: 'Diploma',
    certificate: 'Certificate',
    diploma_content_coming_soon: 'Diploma content will be available soon',
    feedback: 'Feedback',
    downloadPDF: 'Download PDF',
    no_feedback_available_for_the_selected_group: 'No feedback available for the selected group',
    // --------------- Feedback ---------------
    student_feedback: 'Student Feedback',
    write_new_feedback: 'Write New Feedback',
    edit_feedback: 'Edit Feedback',
    feedback_required: 'Feedback is required',
    feedback_too_short: 'Feedback must be at least 10 characters',
    feedback_too_long: 'Feedback cannot exceed 1000 characters',
    write_feedback_placeholder: 'Write your feedback about this student...',
    characters: 'characters',
    save_feedback: 'Save Feedback',
    update_feedback: 'Update Feedback',
    feedback_saved_successfully: 'Feedback saved successfully',
    feedback_updated_successfully: 'Feedback updated successfully',
    failed_to_save_feedback: 'Failed to save feedback',
    failed_to_load_feedback: 'Failed to load feedback',
    feedback_history: 'Feedback History',
    approved_by_admin: 'Approved by Admin',
    pending_admin_approval: 'Pending Admin Approval',
    feedback_access_restricted: 'Only administrators can provide feedback',
    loading_feedback: 'Loading feedback...',
    no_feedback_create_first: 'No feedback yet. Create the first feedback for this student.',
    no_feedback_available: 'No feedback available for this student yet.',
    display_feedback_to_student_and_parent: 'Display feedback to student and parent',
    visible_to_student: 'Visible to student',
    hidden_from_student: 'Hidden from student',
    visible: 'Visible',
    remaining: 'remaining',
    choose_semester: 'Choose a semester',
    semester1: 'First semester',
    semester2: 'Second semester',
    // --------------- Feedback Visibility ---------------
    feedback_already_visible: 'Feedback Already Visible',
    feedback_already_visible_warning:
        'Another feedback is already visible to the student. Only one feedback can be visible at a time. Please hide the current visible feedback first.',
    enable_feedback_visibility: 'Enable Feedback Visibility',
    enable_feedback_visibility_confirmation:
        'Are you sure you want to make this feedback visible to the student and parent?',
    disable_feedback_visibility: 'Disable Feedback Visibility',
    disable_feedback_visibility_confirmation:
        'Are you sure you want to hide this feedback from the student and parent?',
    understood: 'Understood',
    // --------------- Diploma Visibility ---------------
    enable_diploma_visibility: 'Enable Diploma Visibility',
    enable_diploma_visibility_confirmation:
        'Are you sure you want to make diplomas downloadable for all students in this group? This will allow students and parents to download their diplomas.',
    disable_diploma_visibility: 'Disable Diploma Visibility',
    disable_diploma_visibility_confirmation:
        'Are you sure you want to hide diplomas from all students in this group? This will prevent students and parents from downloading diplomas.',
    diploma_visibility_enabled: 'Diploma visibility enabled',
    diploma_visibility_disabled: 'Diploma visibility disabled',
    diploma_available: 'Diploma availability for this group',
    feedback_available: 'Feedback availability for this group',
    space_odyssey_availible: 'Space odyssey availability for this group',
    // --------------- Stripe export ---------------
    from_date: 'From Date',
    to_date: 'To Date',
    from_date_required: 'From date is required',
    to_date_required: 'To date is required',
    to_date_after_from: 'To date must be after from date',
    export_stripe_data: 'Export Stripe Data',
    stripe_export_success: 'Stripe export completed successfully',
    stripe_export_failed: 'Stripe export failed',
    // --------------- Parent Feedback Access ---------------
    no_children_found: 'No children found',
    please_add_children_to_view_feedback: 'Please add children to view their feedback',
    select_child_and_group: 'Please select a child and group to view feedback',
    // --------------- Parent Diploma Access ---------------
    please_add_children_to_view_diploma: 'Please add children to view their diplomas',
    no_diploma_available: 'No diploma available',
    diplomas_not_available_for_group: 'Diplomas are not available for this group yet.',
    loading_diploma_data: 'Loading diploma data...',
    error_loading_diploma_data: 'Error loading diploma data. Please try again.',
    no_diploma_code_found: 'No diploma code found for this student in this group.',
    no_permission_view_diploma: 'You do not have permission to view this diploma.',
    missing_diploma_information: 'Missing group or user information.',
    diploma_not_available_download: 'Diploma is not available for download at this time.',
    // --------------- Diploma Form Fields ---------------
    diploma_information: 'Diploma Information',
    diploma_name: 'Course Name for Diploma',
    diploma_name_helper: 'The course name that will appear on the diploma',
    diploma_description: 'Course Description for Diploma',
    diploma_description_helper: 'A description of what students learned in this course',
    learning_hours: 'Learning Hours',
    learning_hours_helper: 'Total number of learning hours for this course',
    learning_hours_must_be_positive: 'Learning hours must be a positive number',
    admin_password_change: 'Admin Password Change',
    admin_password_change_hint:
        'Leave empty to keep current password. Only admins can change passwords for other users.',
    password_changed_successfully: 'Password changed successfully',
};

export default en;
